import { getFetchedDataPayload } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
export const getAttributeById = (id) => getFetchedDataPayload(browsingDomainStore.data.attributesById[id]);
//# sourceMappingURL=get-attribute-by-id.js.map